<template>
    <nav>
        <!-- menu principal -->
      <v-app-bar app class="lindi darken-2" dark>
        <v-toolbar-title class="headline text-uppercase">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <span>LA PORTADA - </span>
            <span class="font-weight-light">PRODUCCIÓN</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <p>{{user.name}}</p>
        <v-btn class="ma-2" color="red lighten-2" dark  small @click="removeSession">
          <v-icon>
            logout
          </v-icon> 
          salir
        </v-btn>
      </v-app-bar>
        <!-- <TopMenu></TopMenu> -->

        <!-- barra lateral -->
      <v-navigation-drawer 
        dark
        app v-model="drawer" 
        width="270" 
        
        expand-on-hover
        :mini-variant.sync="mini"
        class="lindi darken-1"
      >

        <v-layout mt-4 align-center column>
            <v-flex>
            <v-avatar>
                <v-icon>account_circle</v-icon>
            </v-avatar>
            </v-flex>
            <v-flex>
            
            </v-flex>
        </v-layout>

        <!--  <v-divider></v-divider> -->

        <v-list dense>

          <!-- <v-list-item
            v-for="item in items"
            :key="item.title"
            link
            @click="navigate(item.route)"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          
          <span v-for="item in menues"
            :key="item.id">

            <!-- menu simple -->
            <v-list-item v-if="item.visible && item.tipo == 'single'"
              :key="item.title"
              link
              
              :to="{name:item.route}"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- menu simple -->

            <!-- menu agrupado -->
            <v-list-group
              v-if="item.visible && item.tipo == 'grupo'"
              v-model="item.active"
              :prepend-icon="item.icon"
              no-action
              class="lindi darken-1"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </template>

              <span v-for="subItem in item.items" :key="subItem.id">
                
                <!-- Version anterior de ir a rutas (se uso la nueva para marcar el menu actual)
                  <v-list-item
                  v-if="subItem.visible"
                  :key="subItem.title"
                  @click="navigate(subItem.route)"
                > -->
                <v-list-item
                  v-if="subItem.visible"
                  :key="subItem.title"
                  :to="{name:subItem.route}"
                >
                  <v-list-item-icon class="ma-0 pa-0">
                    <v-icon small>mdi-tilde</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon>
                    <v-icon>{{ subItem.icon }} </v-icon>
                  </v-list-item-icon>
                  &nbsp;
                  <v-list-item-content>              
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </span>
              
            </v-list-group>
          <!-- menu agrupado -->

          </span>

          
        </v-list>
        <template v-slot:append>
          <div class="pa-2">
            <!-- <v-btn block color="red" dark @click="removeSession">Salir</v-btn> -->
          </div>
        </template>     
      </v-navigation-drawer>
    </nav>
</template>
<script>
import {mapMutations,mapState} from 'vuex';
export default {
    data: () => ({
        drawer:false,
        mini:true,
        menuses:[],
        // items:[
        //     {title:'Dashboard',icon:'dashboard',route:'dashboard'},
        //     // {title:'Tipos de Equipo',icon:'merge_type',route:'tipoequipo'},
        //     // {title:'Equipos de Proceso',icon:'devices',route:'equipoproceso'},
        //     // {title:'Indicadores',icon:'label_important',route:'indicadores'},
        //     // {title:'Unidades de Medida',icon:'hdr_strong',route:'unidadmedida'},
        //     // {title:'Puntos de Medición',icon:'group_work',route:'puntomedicion'},
        //     // {title:'Indicador | Detalle',icon:'drag_indicator',route:'indicadordetalle'},
        //     {title:'Laboratorio',icon:'opacity',route:'laboratorio'},
        // ],


        // =============== menus usado anteriormente ==============
        // menus:[
        //   {
        //     title:'Dashboard',
        //     roles_permitidos:['laboratorio','admin'],
        //     icon:'dashboard',
        //     route:'dashboard',
        //     visible:false,
        //     tipo:'single'
        //   },
        //   {
        //     title:'Laboratorio',
        //     roles_permitidos:['laboratorio','admin'],
        //     icon:'opacity',
        //     route:'laboratorio',
        //     visible:false,
        //     tipo:'single'
        //   },
        //   {
        //     icon: 'settings_applications',
        //     roles_permitidos:['admin'],
        //     title: 'Configuraciones',
        //     tipo:'grupo',
        //     active:true,
        //     visible:false,
        //     items:[
        //       {title:'Parametro | Detalle',icon:'drag_indicator',route:'parametrodetalle',visible:false},
        //       {title:'Fórmulas',icon:'perm_data_setting',route:'formulas',visible:false},
        //       {title:'Conf. Tipo Mp Producción',icon:'settings',route:'conftipoproduccionmp',visible:false},
        //     ]
        //   },
        //   {
        //     icon: 'developer_board',
        //     roles_permitidos:['admin'],
        //     title: 'Mantenedores',
        //     tipo:'grupo',
        //     active: false,
        //     visible:false,
        //     items: [
        //       {title:'Tipos de Equipo',icon:'merge_type',route:'tipoequipo',visible:false},
        //       {title:'Tipos de Materia Prima',icon:'directions_boat',route:'tiposmateriasprimas',visible:false},
        //       {title:'Líneas de Proceso',icon:'power_input',route:'lineas',visible:false},
        //       {title:'Pozos',icon:'class',route:'pozos',visible:false},
        //       {title:'Equipos de Proceso',icon:'devices',route:'equipoproceso',visible:false},
        //       {title:'Parametros',icon:'label_important',route:'parametros',visible:false},
        //       {title:'Unidades de Medida',icon:'hdr_strong',route:'unidadmedida',visible:false},
        //       {title:'Puntos de Medición',icon:'group_work',route:'puntomedicion',visible:false},
        //       {title:'Colores',icon:'color_lens',route:'colores',visible:false},
        //     ]
        //   },
        //   {
        //     icon: 'toc',
        //     roles_permitidos:['admin'],
        //     title: 'Producción',
        //     tipo:'grupo',
        //     active: false,
        //     visible:false,
        //     items: [
        //       {title:'Lotes',icon:'ballot',route:'lotes',visible:false},
        //       {title:'Jumbos',icon:'view_week',route:'jumbos',visible:false},
        //       {title:'Estanques de Aceite',icon:'local_drink',route:'estanques',visible:false},
        //       {title:'Turnos',icon:'alarm',route:'turnos',visible:false},
        //       {title:'Insumos de Producción',icon:'local_gas_station',route:'insumos',visible:false},
        //       {title:'Tipos de Producción',icon:'reorder',route:'tiposproduccion',visible:false},
        //     ]
        //   }
        // ]
        // =============== menus usado anteriormente ==============

    }),
    mounted() {
      this.menuses = [];
      this.menuses = this.menus;
    },
    methods:{
        ...mapMutations(['removeSession']),

        navigate(route){
            this.$router.push({name:route});
        }
    },
    computed:{
        ...mapState(['user','roles','menus']),

        // menues(){
        //   this.menus.forEach(m => {
        //     m.roles_permitidos.forEach(r => {
        //       this.roles.forEach(rol_u => {
        //         if(rol_u == r){
        //           m.visible = true;
        //           if(m.tipo == 'grupo'){
        //             m.items.forEach(i => {
        //               i.visible = true;
        //             });
        //           }
        //         }
        //       });
        //     });
        //   });

        //   return this.menus;
        // },

        menues(){
          let lista = [];
          this.menuses.forEach( async menu => {
            if(menu.ruta === '#'){
                lista.push({
                  id:menu.id,
                  tipo: 'grupo',
                  title: menu.texto.toUpperCase(),
                  icon: menu.icono?menu.icono:'label',
                  route:menu.ruta,
                  active:false,
                  visible:true,
                  orden:menu.orden,
                  items:[]
                });
            }else{
              if(menu.debajo_de == null && menu.ruta != '#'){
                 lista.push({
                    id:menu.id,
                    tipo: 'single',
                    title: menu.texto,
                    icon: menu.icono?menu.icono:'label',
                    route:menu.ruta,
                    active:false,
                    visible:true,
                    orden:menu.orden
                 });
              }
            }
          });
          lista.sort(function (a, b) {
            return a.orden - b.orden;
          });
          //console.log('listita',lista);

          lista.forEach(async menu => {
            if(menu.route === '#'){
              await this.menuses.forEach(m => {
                if(m.debajo_de == menu.id){
                  menu.items.push({
                    id:m.id,
                    tipo: 'sub_menu',
                    title: m.texto,
                    icon: m.icono?m.icono:'label',
                    route:m.ruta,
                    active:false,
                    visible:true,
                  });
                }
              });
            }
          });

          return lista;
        },

        menues2(){
          console.log('menus',this.menus);
          let menu_lista = [];
          this.menuses.forEach( async (menu) => {
            if(menu.ruta === '#'){
              /**es un menu de grupo */
              menu_lista.push({
                id:menu.id,
                tipo: 'grupo',
                title: menu.texto,
                icon: menu.icono?menu.icono:'label',
                route:menu.ruta,
                visible:true,
                items:[]
              });
            }else{
              if(menu.debajo_de != null){
                
                await menu_lista.forEach(m => {
                  if(menu.debajo_de == m.id){
                    m.items.push({
                      id:menu.id,
                      tipo: 'sub_menu',
                      title: menu.texto,
                      icon: menu.icono?menu.icono:'label',
                      route:menu.ruta,
                      visible:true,
                    });
                  }
                });
              }else{
                menu_lista.push({
                  id:menu.id,
                  tipo: 'single',
                  title: menu.texto,
                  icon: menu.icono?menu.icono:'label',
                  route:menu.ruta,
                  visible:true
                });
              }
            }
          });
          console.log('menu_lista',menu_lista);
          return menu_lista;
        }
    },
    components:{
    }
}
</script>
<style>
  .v-application .lindi.darken-1 {
    background-color: #5fa8d3 !important;
    border-color: #4c97c2 !important;
  }
  .v-application .lindi.darken-2 {
    background-color: #1a5a80 !important;
    border-color: #124868 !important;
  }
</style>

